import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks';
import {undef} from '../../../utils';

import {SearchIcon} from '../../SearchIcon';

const componentClassNamespace = 'search-form';
const componentBaseClassName = `${componentClassNamespace}__button`;
const componentClassName = `${componentClassNamespace}__submit-button`;

// eslint-disable-next-line complexity
function useComponent() {
    const {
        form: {
            options: {
                showIcons
            },
            settings: {
                hasLoaded,
                isSubmitting
            }
        },
        submit: {
            events: {
                onClick
            },
            options: {
                iconName,
                showIcon
            },
            settings: {},
            translations: {
                labelText
            }
        }
    } = useSearchFormContext();

    const className = classNames(componentBaseClassName, componentClassName);

    const labelIcon = (showIcon || showIcons && showIcon === undef) && (
        <SearchIcon name={iconName}/>
    ) || null;

    const label = (
        <>
            {labelIcon}
            <span>{labelText}</span>
        </>
    );

    const disabled = !hasLoaded || isSubmitting;
    const loading = hasLoaded && isSubmitting;

    function handleClick(...args) {
        onClick(...args);
    }

    const result = {
        className,
        label,
        disabled,
        loading,
        onClick: handleClick
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
